'use client'

import React, { useEffect, useState } from 'react'
import CommandPalette from './CommandPalette'
import { UUID } from '@/utils/idGenerator'
import { usePathname } from 'next/navigation'

export type CommandPaletteStateProps = {
  id?: string
  placeholder: string
}

export default function CommandPaletteState({
  id = UUID(),
  placeholder,
}: CommandPaletteStateProps) {
  const [isOpen, setIsOpen] = useState(false)
  const pathname = usePathname()

  useEffect(() => {
    setIsOpen(false)
  }, [pathname])

  useEffect(() => {
    const isTypingField = (el: Element | null) => {
      if (!el || !(el as HTMLElement)) return false
      const tag = (el as HTMLElement).tagName
      const editable =
        (el as HTMLElement).getAttribute('contenteditable') === 'true'
      return editable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(tag)
    }

    const onKey = (e: KeyboardEvent) => {
      const key = e.key.toLowerCase()

      if (key === '/' && !e.metaKey && !e.ctrlKey && !e.altKey) {
        if (!isTypingField(document.activeElement)) {
          e.preventDefault()
          setIsOpen(true)
        }
      }

      if (key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault()
        setIsOpen((v) => !v)
      }

      if (key === 'escape') setIsOpen(false)
    }

    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [])

  return (
    <CommandPalette
      id={id}
      isOpen={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      placeholder={placeholder}
      autoFocus={true}
    />
  )
}
